import { type VendorPaymentMethodConstructor } from '@webapp/modules/vendor/entities/VendorPaymentMethod'
import { type VendorPaymentMethodApiModel } from '../api-models/VendorPaymentMethodApiModel'

export const mapVendorPaymentMethodApiModel = (
  model: VendorPaymentMethodApiModel
): VendorPaymentMethodConstructor => ({
  id: model.id,
  name: model.name,
  currencyId: model.currency.id,
})
